import React, { useState } from "react";
// my imports:
import Hint from "@/app/components/Hint";
// styles
import hintStyles from "@/app/styles/hint.module.css";

export type OneOffHintProps = {
    position?: {x: number, y: number},
    element?: Element,
    elementOffset?: {x: number, y: number}
    text: string,
    linkText: string,
    setShowing?: React.Dispatch<React.SetStateAction<boolean>>,
    greyOverlay?: boolean
}

export default function OneOffHint({position, element, elementOffset, text, linkText, setShowing, greyOverlay} : OneOffHintProps) {

    const [showIternally, setShowInternally] = useState(true);
    function dismissHint() {
        setShowing ? setShowing(false) : setShowInternally(false);
    }

    if (!showIternally)
        return;

    return(
        <>
            <Hint 
                position={position}
                element={element}
                elementOffset={elementOffset}
                text={text}
                links={[{
                    text: linkText,
                    callback: dismissHint
                }]}
                greyOverlay={greyOverlay}
            />
        </>
    )
}